// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"3e743645","184":"889deb87","408":"24adfd9a","512":"82fb1952","713":"61ac2050"}[chunkId] + ".chunk.css";
};